var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconActivationCriteria01 = function SvgIconActivationCriteria01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_activation_criteria-01_svg2__a",
    x1: -42.97,
    x2: 82.99,
    y1: 105.17,
    y2: 23.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_activation_criteria-01_svg2__a",
    id: "icon_activation_criteria-01_svg2__b",
    x1: -53.6,
    x2: 72.36,
    y1: 88.86,
    y2: 6.71
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_activation_criteria-01_svg2__a",
    id: "icon_activation_criteria-01_svg2__c",
    x1: -28.07,
    x2: 97.89,
    y1: 128.01,
    y2: 45.86
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_activation_criteria-01_svg2__a",
    id: "icon_activation_criteria-01_svg2__d",
    x1: -38.71,
    x2: 87.25,
    y1: 111.7,
    y2: 29.55
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_activation_criteria-01_svg2__a",
    id: "icon_activation_criteria-01_svg2__e",
    x1: -40.47,
    x2: 85.49,
    y1: 109,
    y2: 26.85
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M76.14 38.93H51.72c-1.91 0-3.49-1.58-3.49-3.49s1.58-3.49 3.49-3.49h24.42c1.91 0 3.49 1.58 3.49 3.49s-1.53 3.49-3.49 3.49",
    style: {
      fill: "url(#icon_activation_criteria-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3 42.47a3.5 3.5 0 0 1-2.47-1.02l-3.49-3.49c-1.35-1.35-1.35-3.58 0-4.93s3.58-1.35 4.93 0l1.02 1.02 8-8c1.35-1.35 3.58-1.35 4.93 0s1.35 3.58 0 4.93L29.75 41.45a3.48 3.48 0 0 1-2.47 1.02Z",
    style: {
      fill: "url(#icon_activation_criteria-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.14 71.49H51.72c-1.91 0-3.49-1.58-3.49-3.49s1.58-3.49 3.49-3.49h24.42c1.91 0 3.49 1.58 3.49 3.49s-1.53 3.49-3.49 3.49",
    style: {
      fill: "url(#icon_activation_criteria-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3 75.02A3.5 3.5 0 0 1 24.83 74l-3.49-3.49c-1.35-1.35-1.35-3.58 0-4.93s3.58-1.35 4.93 0l1.02 1.02 8-8c1.35-1.35 3.58-1.35 4.93 0s1.35 3.58 0 4.93L29.75 74a3.48 3.48 0 0 1-2.47 1.02Z",
    style: {
      fill: "url(#icon_activation_criteria-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.95 100H36.04C10.79 100 0 89.21 0 63.95V36.04C0 10.79 10.79 0 36.05 0h27.91c25.26 0 36.05 10.79 36.05 36.05v27.91c0 25.26-10.79 36.05-36.05 36.05ZM36.05 6.98c-21.44 0-29.07 7.63-29.07 29.07v27.91c0 21.44 7.63 29.07 29.07 29.07h27.91c21.44 0 29.07-7.63 29.07-29.07V36.05c0-21.44-7.63-29.07-29.07-29.07z",
    style: {
      fill: "url(#icon_activation_criteria-01_svg2__e)"
    }
  }));
};
export default SvgIconActivationCriteria01;